import { useCallback, useState } from 'react';

export const useBuilderSelection = () => {
  const [selectedSectionId, setSelectedSectionId] = useState(null);
  const [selectedFieldId, setSelectedFieldId] = useState(null);
  const [selectedFieldIds, setSelectedFieldIds] = useState([]);
  const [propertyPanelOpen, setPropertyPanelOpen] = useState(false);

  const selectField = useCallback((fieldId, sectionId, { multi = false, range = false, openPanel = true } = {}) => {
    if (sectionId != null) setSelectedSectionId(sectionId);
    setSelectedFieldId(fieldId);
    if (openPanel) setPropertyPanelOpen(true);

    if (multi && fieldId) {
      setSelectedFieldIds((prev) =>
        prev.includes(fieldId) ? prev.filter((id) => id !== fieldId) : [...prev, fieldId]
      );
    } else if (range) {
      setSelectedFieldIds((prev) => (prev.includes(fieldId) ? prev : [...prev, fieldId]));
    } else {
      setSelectedFieldIds(fieldId ? [fieldId] : []);
    }
  }, []);

  const selectSection = useCallback((sectionId) => {
    setSelectedSectionId(sectionId);
    setSelectedFieldId(null);
    setSelectedFieldIds([]);
  }, []);

  const clearSelection = useCallback(() => {
    setSelectedFieldId(null);
    setSelectedFieldIds([]);
  }, []);

  return {
    selectedSectionId,
    selectedFieldId,
    selectedFieldIds,
    propertyPanelOpen,
    setPropertyPanelOpen,
    selectField,
    selectSection,
    clearSelection,
    setSelectedSectionId,
  };
};

export default useBuilderSelection;
